export const getters = {
  product: state => state.product,
  products: state => state.products
}

const GET_PRODUCTS = 'product/products'

export const gettersTypes = {
  GET_PRODUCTS
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/product/getters.js